import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as i, normalizeClass as d, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconReplyAll",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.354 3.146a.5.5 0 0 1 0 .708L2.207 6l2.147 2.146a.5.5 0 1 1-.708.708l-2.5-2.5a.5.5 0 0 1 0-.708l2.5-2.5a.5.5 0 0 1 .708 0Zm2.5 0a.5.5 0 0 1 0 .708L5.207 5.5H9.5A2.5 2.5 0 0 1 12 8v1a.5.5 0 0 1-1 0V8a1.5 1.5 0 0 0-1.5-1.5H5.207l1.647 1.646a.5.5 0 1 1-.708.708l-2.5-2.5a.5.5 0 0 1 0-.708l2.5-2.5a.5.5 0 0 1 .708 0Z",
  "clip-rule": "evenodd"
}, null, -1), m = [
  _
];
function u(e, p, l, f, h, a) {
  return i(), r("svg", {
    "aria-label": l.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--reply-all"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Reply All",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 12"
  }, m, 10, c);
}
const y = /* @__PURE__ */ o(s, [["render", u]]);
export {
  y as default
};
//# sourceMappingURL=reply-all.js.map
